import { Pipe, PipeTransform } from '@angular/core';
import { FeaturedElementsDeprecatedService } from "@/core/services/featured-elements-deprecated.service";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FeaturedElementFragment } from "@/core/graphql/graphql";

@Pipe({
  name: 'featuredElement',
  pure: true,
})
export class FeaturedElementPipe implements PipeTransform {
  public constructor(private readonly _featuredElementsService: FeaturedElementsDeprecatedService) { }

  public transform(id: number): Observable<boolean> {
    return this._featuredElementsService.getFeaturedElements().pipe(
      map((next: FeaturedElementFragment[]) => next.map(item => item.id).includes(id, 0)),
    );
  }
}
